import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface OfflineGateway {
  id: string;
  claim_code: string;
  property_name: string | null;
  org_name: string | null;
  lifecycle_status: string;
  operational_status: string;
  last_heartbeat_at: string | null;
}

export interface StripeConnectIncomplete {
  id: string;
  name: string;
  stripe_connect_account_id: string;
  charges_enabled: boolean;
  payouts_enabled: boolean;
}

export interface FailedImportJob {
  id: string;
  org_name: string | null;
  provider_type: string;
  status: string;
  total_plants: number;
  processed_plants: number;
  created_at: string;
  completed_at: string | null;
}

export interface NotificationFailure {
  id: string;
  property_name: string | null;
  title: string;
  severity: string;
  email_error: string | null;
  sms_error: string | null;
  created_at: string;
}

export interface SupportOverviewData {
  total_orgs: number;
  total_properties: number;
  properties_by_readiness_state: Record<string, number>;
  active_service_subscriptions: number;
  open_customer_issues: number;
  offline_gateways: OfflineGateway[];
  stripe_connect_not_onboarded: StripeConnectIncomplete[];
  recent_failed_import_jobs: FailedImportJob[];
  recent_notification_failures: NotificationFailure[];
}

async function fetchSupportOverview(): Promise<SupportOverviewData> {
  const { data, error } = await supabase.rpc('admin_support_overview');
  if (error) throw error;
  return data as SupportOverviewData;
}

export function useAdminSupportOverview(enabled: boolean, refetchInterval: number | false) {
  return useQuery({
    queryKey: ['admin-support-overview'],
    queryFn: fetchSupportOverview,
    enabled,
    refetchInterval,
  });
}
